function normalizedBasePath(baseUrl: string): string {
  const pathname = new URL(baseUrl || '/', 'https://paradox.local').pathname
  if (pathname === '/') return ''
  return `/${pathname.split('/').filter(Boolean).join('/')}`
}

export const APP_BASE_PATH = normalizedBasePath(import.meta.env.BASE_URL)

export function stripBasePath(pathname: string, basePath = APP_BASE_PATH): string {
  const normalizedBase = normalizedBasePath(basePath || '/')
  if (!normalizedBase) return pathname || '/'
  if (pathname === normalizedBase || pathname === `${normalizedBase}/`) return '/'
  if (pathname.startsWith(`${normalizedBase}/`)) return pathname.slice(normalizedBase.length) || '/'
  return pathname || '/'
}

export function withBasePath(to: string, basePath = APP_BASE_PATH): string {
  const normalizedBase = normalizedBasePath(basePath || '/')
  if (!normalizedBase || !to.startsWith('/') || to.startsWith('//')) return to
  if (to === normalizedBase || to.startsWith(`${normalizedBase}/`)) return to
  return `${normalizedBase}${to}`
}

export function publicUrl(path: string, basePath = APP_BASE_PATH): string {
  const normalizedBase = normalizedBasePath(basePath || '/')
  return `${normalizedBase}/${path.replace(/^\/+/, '')}`
}
